import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromProjects from '../reducers/project.reducers';
export const selectProjectsState = createFeatureSelector<fromProjects.State>('projects');
export const selectProjects = createSelector(
    selectProjectsState,
    (state: fromProjects.State) => state.projects
);
export const selectProjectsErrorMessage = createSelector(
    selectProjectsState,
    (state: fromProjects.State) => state.errorMessage
);
export const selectIsProjectsLoading = createSelector(
    selectProjectsState,
    (state: fromProjects.State) => state.isLoading
);
export const selectProjectById = (projectId: string) => createSelector(
    selectProjectsState,
    (state: fromProjects.State) => state.projects.find(project => project.id === projectId)
);

export const selectCreateProjectSuccess = createSelector(
    selectProjectsState,
    (state: fromProjects.State) => state.createSuccess
);


